import styled from 'styled-components';

export const Circle = styled.div`
  width: 25px;
  height: 25px;
`;

export const ContainerTable = styled.div`
  .rdt_TableHeadRow {
    color: ${(props) => props.theme.$gray700};
    background-color: ${(props) => props.theme.$gray200};
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 0.2rem 0.2rem 0 0;

    div {
      color: ${(props) => props.theme.$gray700};
      white-space: inherit;
      font-size: 14px;

      &:first-child {
        order: 4;
      }
    }
  }

  .rdt_TableRow {
    border: 1px solid ${(props) => props.theme.$gray300};
    border-top: 0;

    &:last-child {
      border-radius: 0 0 0.2rem 0.2rem;
    }

    div:first-child {
      order: 4;

      button {
        svg {
          fill: ${(props) => props.theme.$primary};
        }

        &[aria-label='Expand Row'] svg {
          rotate: 90deg;
        }

        &[aria-label='Collapse Row'] svg {
          rotate: 180deg;
        }
      }
    }
  }

  .rdt_TableCol:nth-of-type(5) {
    text-align: center;
  }

  .rdt_TableCell {
    padding-bottom: 15px;
    padding-top: 15px;
  }

  .rdt_ExpanderRow {
    padding: 15px;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-top: 0;
  }
`;

export const ButtonStyles = styled.div`
  button {
    margin-right: 10px;
    color: #007bff;
  }
`;

export const SearchStyles = styled.div`
  .list-group-scrollable {
    max-height: 10em;
    overflow-y: auto;
  }

  .container-audio-preview {
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 0.25rem;
    height: 51px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
  }
  .audio-equalizer-bars,
  .audio-cancel,
  .audio-submit {
    background: transparent;
    color: ${(props) => props.theme.$gray600};
    border-radius: 0px;
    padding: 2px;
    &:disabled {
      cursor: default;
    }
    &:hover {
      background: ${(props) => props.theme.$gray300};
      padding: 2px;
      border-radius: 4px;
    }
  }
`;

export const ContainerText = styled.div`
  height: 75vh;
  overflow-y: scroll;

  ol {
    padding-left: 25px;
  }
`;

export const Badge = styled.div`
  .badge-secondary {
    color: #808080;
    background-color: #efefef !important;
    font-size: 14px;
  }
`;
